import React from "react";

const ErrorState: React.FC = () => {
  return (
    <div className="flex-1 overflow-auto pb-16 px-4">
      <div className="bg-red-50 rounded-xl p-6 my-4 text-center">
        <h3 className="text-red-500 text-lg font-medium">
          Error loading content
        </h3>
        <p className="text-red-400 mt-2">Please try refreshing the page</p>
      </div>
    </div>
  );
};

export default ErrorState;
